const STAFF_FETCH_SERVICE_LOCATIONS = 'staff_fetch_service_locations';
const STAFF_FETCH_SERVICE_LOCATION = 'staff_fetch_service_location';
const STAFF_DELETE_SERVICE_LOCATION = 'staff_delete_service_location';
const STAFF_PERSIST_SERVICE_LOCATION = 'staff_persist_service_location';

export default {
    STAFF_FETCH_SERVICE_LOCATIONS,
    STAFF_FETCH_SERVICE_LOCATION,
    STAFF_DELETE_SERVICE_LOCATION,
    STAFF_PERSIST_SERVICE_LOCATION,
};
